import { gql } from '@apollo/client'

export const FETCH_BLOCKED_USER = gql(`
  query FetchBlockedUser($boardId: ID!) {
    findBoard(id: $boardId) {
      id
      title
      owner {
        id
        firstname
        lastname
        username
        avatar
        legacyEid
        profilePhotoUrl
        followers {
          followersCount
        }
        followees {
          followeesCount
        }
        followsUser
      }
      network {
        id
        title
        name
      }
      loggedInBoardUser {
        __typename
        ... on BoardMember {
          role
          boardId
          userId
          user {
            id
            firstname
            lastname
            username
            avatar
            legacyEid
            profilePhotoUrl
            blockFromBoard(boardId: $boardId) {
              id
              reason
            }
          }
        }
        ... on BoardViewer {
          boardId
          userId
          user {
            id
            firstname
            lastname
            username
            avatar
            legacyEid
            profilePhotoUrl
            blockFromBoard(boardId: $boardId) {
              id
              reason
            }
          }
        }
      }
    }
  }
`)
